import React from 'react';

type InlineStatusSkeletonProps = {
  variant?: 'desktop' | 'mobile';
};

const InlineStatusSkeleton: React.FC<InlineStatusSkeletonProps> = ({ variant = 'desktop' }) => {
  const isDesktop = variant === 'desktop';

  return (
    <div
      role="status"
      aria-label="Loading status"
      className={`flex flex-col items-center justify-center w-full relative overflow-hidden ${
        isDesktop ? 'py-6' : 'py-4'
      }`}
    >
      <div className="absolute inset-0 w-full h-full animate-shimmer bg-gradient-to-r from-transparent via-white/60 to-transparent z-10 pointer-events-none" />
      <div className={`bg-gray-200/70 rounded-full animate-pulse mb-4 ${isDesktop ? 'w-10 h-10' : 'w-8 h-8'}`} />
      <div className={`h-4 bg-gray-200/70 rounded animate-pulse ${isDesktop ? 'w-48' : 'w-36'}`} />
      <span className="sr-only">Loading status...</span>
    </div>
  );
};

export default InlineStatusSkeleton;
